export const filteredItems = (item, query, field) =>
  item?.filter((item) => {
    return item[field]?.toLowerCase().includes(query.toLowerCase());
  });
